(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (function () {
    var SELECTORS = ['.product-details .text-block'];
    var CM_TO_IN = 0.393700787;

    function toInches(value, unit) {
      var cm = unit === 'mm' ? value / 10 : unit === 'm' ? value * 100 : value;
      var inches = cm * CM_TO_IN;
      var rounded = Math.round(inches * 10) / 10;
      return rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(1);
    }

    var RE = /(\d+(?:[.,]\d+)?)\s?(mm|cm|m)\b(?!\s?[²2])/gi;

    function processNode(root) {
      if (!root || root.dataset.inConverted === '1') return;

      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);

      nodes.forEach(function (node) {
        var text = node.nodeValue;
        if (!RE.test(text)) return;
        RE.lastIndex = 0;

        var converted = text.replace(RE, function (match, num, unit) {
          var v = parseFloat(num.replace(',', '.'));
          return toInches(v, unit.toLowerCase()) + ' in';
        });

        if (converted === text) return;

        var span = document.createElement('span');
        span.className = 'dimensions-inch';
        span.style.display = 'block';
        span.style.opacity = '0.65';
        span.textContent = converted.trim();

        node.parentNode.insertBefore(span, node.nextSibling);
      });

      root.dataset.inConverted = '1';
    }

    function run() {
      SELECTORS.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(processNode);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
